import { trackEvent } from '../analytics/helpers.js';

/**
 * Track a step of the checkout process using Google Analytics and their
 * recommended events. See https://developers.google.com/analytics/devguides/collection/ga4/reference/events?sjid=8256709344012883295-NA&client_type=gtag#purchase
 *
 * @param {string} step - The step of the checkout process
 * @param {Object} currentState - The current state of the checkout process
 * @param {number} currentState.donationAmount - The amount of the donation
 * @param {string} currentState.donationFrequency - The frequency of the
 *  donation
 * @param {string} currentState.benefitDesired - Whether the donor wants to
 *  receive a benefit
 * @param {string[]} currentState.subscriptions - The subscriptions the donor
 *  wants to sign up for
 */
export function trackCheckoutStep(step, currentState) {
  if (step === 'intent') {
    trackEvent('begin_checkout', formatEventData(currentState));
  } else if (step === 'contact') {
    trackEvent('add_shipping_info', formatEventData(currentState));
  } else if (step === 'payment') {
    trackEvent('add_payment_info', {
      payment_type: 'Stripe',
      ...formatEventData(currentState),
    });
  } else if (step === 'review') {
    trackEvent('purchase', {
      newsletters: currentState.subscriptions,
      cover_fees: currentState.coverFees,
      ...formatEventData(currentState),
    });
  }
}

/**
 * Format the data for a GA4 event.
 * @param {Object} currentState - The current state of the checkout process
 * @param {number} currentState.donationAmount - The amount of the donation
 * @param {string} currentState.donationFrequency - The frequency of the
 *  donation
 * @param {string} currentState.benefitDesired - Whether the donor wants to
 *  receive a benefit
 * @returns {Object} - The formatted data
 * @private
 */
function formatEventData(currentState) {
  return {
    currency: 'USD',
    value: currentState.donationAmount,
    donation_frequency: currentState.donationFrequency,
    benefit_desired: currentState.benefitDesired,
    items: [
      {
        item_name: `Donate ${currentState.donationFrequency}`,
      },
    ],
  };
}
